export default "__VITE_ASSET__BkBz_out__"